<template>
<div class="input-wrapper" ref="wrapper" :style="inputGrpStyle">
  <input v-if="edtiable"
         :class="className"
         :type="type"
         :value="value"
         :name="name"
         @blur="handleBlur"
         @keypress="handleKeypress"
         @keypress.enter="handleBlur"
         @change="handleChange"
         :id="id"
         ref="input"
         :placeholder="placeholder" />
      <label :for="id" v-if="!edtiable" class="input-group" @click="handleIconClick">
        <span class="placeholder">{{showText}}</span>
        <i class="iconfont icon-pencil"></i>
      </label>
</div>
</template>
<style lang="scss">
.input-wrapper {
  input {
    width: 100%;
    display: inline-block;

    &::placeholder {
      color: rgba(18, 150, 219, 0.8);
    }
  }

  .icon-pencil {
    opacity: .7;
  }
}
.input-group {
  display: flex;
  flex-direction: row;
  align-items: center;

  .placeholder {
    display: inline-block;
    color: rgba(0, 0, 0, 1);
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.2;
  }

  i.iconfont {
    cursor: pointer;

    &:hover {
      color: rgba(18,150,219, 1);
    }
  }
}

.edit-text {
  input {
    line-height: rem(30px);
  }
}

.edit-url {
  input {
    line-height: rem(22px);
  }
  .placeholder {
    border: none;
  }
} 

</style>

<script>
export default {
  name: "editableInput",

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    defaultPrefix: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      initWidth: 0,
      edtiable: false,
    }
  },

  mounted() {
    this.bindWidth();
    window.addEventListener('resize', this.bindWidth);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.bindWidth);
  },

  computed: {
    showText() {
      return this.value && this.value.length > 0 ? this.value : this.placeholder;
    },
    inputGrpStyle() {
      return {
        maxWidth: this.initWidth ? `${this.initWidth}px` : 'auto',
      }
    }
  },

  methods: {
    bindWidth() {
      const parent = this.$refs.wrapper.parentElement;
      if (parent) {
        this.initWidth = parent.getBoundingClientRect().width;
      }
    },
    handleKeypress(e) {
      if (this.defaultPrefix && this.defaultPrefix.length > 0) {
        const val = e.currentTarget.value || ``;
        if (val.length <= 0) {
          e.currentTarget.value = `${this.defaultPrefix}${val}`;
        }
      }
    },
    handleChange(e) {
      this.$emit('change', e.target.value);
    },
    handleBlur() {
      this.edtiable = false;
    },

    handleIconClick() {
      this.edtiable = true;
      this.$nextTick(()=>{
        this.$refs.input.focus();
      })
    },
  }
}
</script>